<div class="header">
  @if (firebase.isLoggedIn()) {
    @if (firebase.impersonation(); as session) {
      <div class="impersonation-banner" role="status">
        <span>Estás viendo la cuenta de {{ session.name || session.email }}.</span>
        <button mat-button type="button" [disabled]="leavingImpersonation()" (click)="leaveImpersonation()">
          {{ leavingImpersonation() ? 'Volviendo…' : 'Volver a tu cuenta' }}
        </button>
      </div>
    }
  }
  <mat-toolbar color="primary" class="app-toolbar">
    @if (firebase.isLoggedIn()) {
      <button
        mat-icon-button
        type="button"
        class="toolbar-menu"
        appGuideAnchor="toolbar-menu"
        aria-label="Menú"
        (click)="sideNav.toggle()"
      >
        <mat-icon>menu</mat-icon>
      </button>
    }
    <img
      src="assets/images/interconsulta_icon_white.png"
      alt=""
      class="toolbar-icon"
      width="96"
      height="96"
    />
    @if (!layout.isPhone() || !firebase.isLoggedIn()) {
      <img
        src="assets/images/interconsulta_wordmark_white.png"
        alt="Interconsulta"
        class="toolbar-wordmark"
        width="801"
        height="77"
      />
    }
    @if (firebase.isLoggedIn() && membership.selectedBusinessName(); as businessName) {
      <button
        mat-button
        type="button"
        class="toolbar-business"
        appGuideAnchor="toolbar-clinic"
        [matMenuTriggerFor]="businessMenu"
        [disabled]="!businessMenuEnabled()"
        [attr.aria-label]="'Clínica: ' + businessName"
      >
        <span class="toolbar-business-name">{{ businessName }}</span>
        @if (businessMenuEnabled()) {
          <mat-icon>arrow_drop_down</mat-icon>
        }
      </button>
      <mat-menu #businessMenu="matMenu">
        @for (m of membership.memberships(); track m.businessId) {
          <button
            mat-menu-item
            [class.toolbar-business-selected]="m.businessId === membership.selectedBusinessId()"
            (click)="onSelectBusiness(m.businessId)"
          >
            {{ m.businessName }}
          </button>
        }
        @if (canCreateBusiness()) {
          <mat-divider></mat-divider>
          <button mat-menu-item type="button" (click)="openNewBusiness()">
            <mat-icon>add_business</mat-icon>
            <span>Nuevo consultorio</span>
          </button>
        }
      </mat-menu>
      @if (!layout.isCompact()) {
        @if (userProfile.doctorLabel(); as label) {
          <span class="toolbar-doctor">· {{ label }}</span>
        }
      }
    }

    <span class="toolbar-spacer"></span>

    @if (firebase.isLoggedIn() && !kiosk.locked()) {
      @if (layout.isCompact()) {
        <button mat-icon-button type="button" aria-label="Cuenta" [matMenuTriggerFor]="accountMenu">
          <mat-icon>account_circle</mat-icon>
        </button>
        <mat-menu #accountMenu="matMenu" xPosition="before">
          @if (userProfile.doctorLabel(); as label) {
            <div class="account-menu-label">{{ label }}</div>
          }
          <button mat-menu-item type="button" (click)="toggleTheme()">
            <mat-icon>{{ theme.preference() === 'dark' ? 'light_mode' : 'dark_mode' }}</mat-icon>
            <span>{{ theme.preference() === 'dark' ? 'Modo claro' : 'Modo oscuro' }}</span>
          </button>
          <button mat-menu-item type="button" (click)="firebase.logout()">
            <mat-icon>logout</mat-icon>
            <span>Cerrar sesión</span>
          </button>
        </mat-menu>
      } @else {
        <span class="theme-toggle">
          <mat-icon class="theme-toggle-icon" aria-hidden="true">light_mode</mat-icon>
          <mat-slide-toggle
            [checked]="theme.preference() === 'dark'"
            [attr.aria-label]="theme.preference() === 'dark' ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'"
            (change)="theme.setPreference($event.checked ? 'dark' : 'light')"
          ></mat-slide-toggle>
          <mat-icon class="theme-toggle-icon" aria-hidden="true">dark_mode</mat-icon>
        </span>
        <button mat-button type="button" (click)="firebase.logout()">Cerrar Sesión</button>
      }
    }
  </mat-toolbar>
</div>
<mat-sidenav-container class="shell-sidenav" [hasBackdrop]="layout.isCompact()">
  <mat-sidenav
    fixedInViewport="true"
    [fixedTopGap]="sideNavTopGap()"
    #sideNav
    class="side-nav"
    [autoFocus]="false"
    (click)="sideNav.close()"
    (openedChange)="onSideNavOpenedChange()"
    (closedStart)="onSideNavClosing()"
  >
    <app-side-menu></app-side-menu>
  </mat-sidenav>
  <mat-sidenav-content
    (click)="sideNav.close()"
    id="sidenav-content"
    [class.auth-sidenav]="isAuthLayout()"
  >
    <div id="page-content" [class.auth-layout]="isAuthLayout()">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
@if (routeLoading()) {
  <div class="route-loader" role="status" aria-label="Cargando">
    <mat-spinner diameter="48"></mat-spinner>
  </div>
}
<app-guide-overlay />
